import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import React, {useEffect, useState} from "react";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import RaikoCustomEditor from "../../raikoComponents/raikoEditor/RaikoCustomEditor";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import RaikoCustomSelect, {
    raikoCustomSelectItemGenerator
} from "../../raikoComponents/raikoCustomSelect/RaikoCustomSelect";
import {NEWS_TYPES, NewsService} from "../../serverService/newsService/NewsService";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";
import RaikoConfirmDialog from "../../raikoComponents/raikoCustomDialogs/RaikoConfirmDialog";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import RaikoGridThreeColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridThreeColumn";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";
import {css} from "@emotion/css";
import DatePicker, {DateObject} from "react-multi-date-picker"

export default function NewsDetailBaseInfo({newsId}) {

    const service = new NewsService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof newsId !== "undefined" && newsId >= 0) {
            getNewsInfoFromServer()
        }
    }, [newsId]);

    function getNewsInfoFromServer() {
        loading.show()
        service.getNewsGlobalInfo(newsId)
            .then((
                {
                    newsInformation,
                    newsPublished,
                    newsContent
                }) => {
                setDescription(newsContent)
                setNewsInformation(newsInformation)

                setEnabled(newsPublished.published)

                if (newsPublished.publishDate && newsPublished.publishDate.length > 0)
                    setPublishedDate(new Date(newsPublished.publishDate))

                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئیات خبر"))
            loading.hide()
        })
    }

    function setNewsInformation(newsInformation) {
        setTitle(newsInformation.title)
        setNewsType(newsInformation.type)
        setShortDescription(newsInformation.shortDescription)

        setCreatedAt(convertUniversalDateToPersianDate(newsInformation.createdAt))
        setCreatedBy(newsInformation.createdBy)
        setTimeToRead(newsInformation.timeToRead ? newsInformation.timeToRead : "نا مشخص")

    }


    const [title, setTitle] = useState("");
    const [newsType, setNewsType] = useState(NEWS_TYPES.NEWS.id);
    const [shortDescription, setShortDescription] = useState("");
    const [description, setDescription] = useState("");
    const [publishedDate, setPublishedDate] = useState("");

    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [timeToRead, setTimeToRead] = useState("");

    const [enabled, setEnabled] = useState(true);

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }

    function checkFields() {
        let message = ""
        let state = false

        if (title === null || title.trim().length === 0)
            message = "لطفا عنوان خبر را وارد نمایید!"
        else if (shortDescription === null || shortDescription.trim().length === 0)
            message = "لطفا توضیحات کوتاه خبر را وارد نمایید!"
        else
            state = true

        if (message)
            snackbar.showWarningMessage(message)

        return state
    }

    function handleUpdateNewsInformation() {
        if (checkFields()) {
            loading.show()
            service.updateNewsInformation(newsId, title, newsType, shortDescription)
                .then(response => {
                    snackbar.showSuccessMessage("جزئیات خبر با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {

                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی جزئيات خبر"))
                loading.hide()
            })
        }
    }

    function handleChangeEnableSetting() {
        if (publishedDate) {

            loading.show()
            const _newPublishDate = new DateObject(publishedDate).format("YYYY-MM-DD")

            service.changePublishedState(newsId, !enabled, _newPublishDate)
                .then(response => {
                    setConfirmDialogOpenState(false)
                    setEnabled(response.published)

                    snackbar.showSuccessMessage("وضعیت انتشار خبر با موفقیت تغییر یافت.")
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در تغییر وضعیت انتشار خبر."))
                loading.hide()
            })
        } else {
            snackbar.showWarningMessage("لطفا تاریخ انتشار را انتخاب نمایید.")
        }

    }

    function handleUpdateNewsContent() {
        if (description.length > 0) {
            loading.show()
            service.updateNewsContent(newsId, description)
                .then(response => {
                    snackbar.showSuccessMessage("متن توضیحات خبر با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی متن خبر."))
                loading.hide()
            })
        } else {
            snackbar.showWarningMessage("لطفا ابتدا توضیحات خبر را وارد نمایید.")
        }
    }

    function handleUpdatePublishedDate() {


        if (publishedDate) {
            const _newPublishDate = new DateObject(publishedDate).format("YYYY-MM-DD")
            loading.show()

            service.changePublishedState(newsId, enabled, _newPublishDate)
                .then(response => {

                    snackbar.showSuccessMessage("تاریخ انتشار خبر با موفقیت تغییر یافت.")
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تاریخ انتشار"))
            }).finally(_ => {
                loading.hide()
            })


        } else {
            snackbar.showWarningMessage("لطفا تاریخ انتشار را انتخاب نمایید.")
        }
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"انتشار مقاله"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!enabled ? "انتشار" : "عدم انتشار"}
            />

            <RaikoGridOneColumn>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoLabel text={"اطلاعات پایه"} className={css`margin-bottom: .5rem`}/>
                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"عنوان خبر"}
                                setValue={setTitle}
                                value={title}
                            />

                            <RaikoCustomSelect
                                labelText={"نوع خبر"}
                                setValue={setNewsType}
                                items={[
                                    raikoCustomSelectItemGenerator(NEWS_TYPES.NEWS.id, NEWS_TYPES.NEWS.title),
                                    raikoCustomSelectItemGenerator(NEWS_TYPES.EXECUTIVE_COMMITTEE.id, NEWS_TYPES.EXECUTIVE_COMMITTEE.title),
                                    raikoCustomSelectItemGenerator(NEWS_TYPES.CRAFT_UNION.id, NEWS_TYPES.CRAFT_UNION.title),
                                ]}
                                value={newsType}
                            />
                        </RaikoGridTwoColumn>

                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"توضیحات کوتاه"}
                            setValue={setShortDescription}
                            value={shortDescription}
                        />

                        <ButtonDivisionSection>
                            <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateNewsInformation}/>
                        </ButtonDivisionSection>

                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoCustomEditor
                            defaultEditorData={description}
                            setLastEditorData={setDescription}
                        />

                        <ButtonDivisionSection>
                            <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateNewsContent}/>
                        </ButtonDivisionSection>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoLabel text={"اطلاعات ساخت"} className={css`margin-bottom: .5rem`}/>

                        <RaikoGridThreeColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"تاریخ ساخت"}
                                setValue={setCreatedAt}
                                value={createdAt}
                                disabled={true}/>

                            <RaikoSimpleInputOutlined
                                labelText={"سازنده"}
                                setValue={setCreatedBy}
                                value={createdBy}
                                disabled={true}/>

                            <RaikoSimpleInputOutlined
                                labelText={"زمان خواندن"}
                                setValue={setTimeToRead}
                                value={timeToRead}
                                disabled={true}/>
                        </RaikoGridThreeColumn>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"وضعیت انتشار"}
                            description={[
                                "* با فعالسازی این مورد کاربران قادر به مشاهده ی این مقاله خواهند بود و در غیر این صورت مقاله تنها به عنوان پیش نویس در پنل مدیریت باقی خواهند ماند.",
                            ]}
                        />
                        <div
                            className={css`
                              display: flex;
                              flex-wrap: nowrap;
                              gap: .5rem;
                              width: 100%;
                              flex-grow: 1;

                              > div {
                                width: 100%;
                                flex-grow: 1;
                              }
                            `}>
                            <DatePicker
                                placeholder={"تاریخ انتشار"}
                                inputClass={`custom-input`}
                                className={css`flex-grow: 1;`}
                                mapDays={({date}) => {
                                    let props = {}
                                    let isWeekend = date.weekDay.index === 6

                                    if (isWeekend) props.className = "highlight highlight-red"

                                    return props
                                }}
                                // render={<InputIcon/>}
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-right"
                                value={publishedDate}
                                onChange={event => {
                                    setPublishedDate(event.toDate())

                                    /*getDataFromServer(
                                        setTicketFilterReservedDate(new DateObject(event.toDate()).format("YYYY-MM-DD"))
                                    )*/

                                }}
                            />
                            <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdatePublishedDate}/>
                        </div>
                        <RaikoToggleOutlined
                            labelText={"انتشار (منتشر شده / در انتظار انتشار)"}
                            setChecked={state => {
                                handleOpenConfirmDialog()
                            }}
                            checked={enabled}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>


            </RaikoGridOneColumn>
        </>
    )
}